import { Text, Box, Heading, Image, Button, Flex, Grid, GridItem,  Icon  } from "@chakra-ui/react";
import query_tool from './images/querytool.png'
import uploadDataset from "./images/uploadDataset.png"
import BgImage from './images/BgImage.jpg'
import DescriptionCardWP from "./DescriptionCardWP";
import { useNavigate} from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

export default  function WelcomePage() {
    const navigate = useNavigate();
    const goToAmeliaDP = () => {
        sessionStorage.setItem("username", "anonymous");
        navigate('/login')
        window.location.reload()
      }
    

return (
    <Box h="100%" w="100%" bgColor="#f6f3ec" overflowY="auto">
    <Box h="10%" w="100%" paddingLeft="10px">
      <Heading  fontFamily="inherit" fontWeight="bold" color="green.400">
        Welcome to AMELIA
      </Heading>
    </Box>

    <Box
      display="flex"
      w="98%"
      marginLeft={"1%"}
      marginRight={"1%"}
     
      
    >
      {/* Testo a sinistra */}
      <Box flex={1} bg="#003b47" color="white" p={5} borderRadius="lg" margin={"2%"}>
      <Flex justify="space-between" mb={8}>
        <Box maxW="95%">
         
          <Heading as="h2" fontSize="3xl" mb={4}>
            Public Area
          </Heading>
          <Text fontSize="lg">
          This is the public area, here you can see the datasets and the
          public dashboards in the platform. By logging in
          You will be able to have access to the entire platform. Amelia is a date
          platform that allows you to upload data in multiple formats,
          analyze them through integrated tools, such as the
          server queries, save and share your results with others
          all in the same platform.
        
          </Text>
        </Box>
        {/* Pulsante "Vedi Tutti" */}
       
      </Flex>
        
      </Box>
    </Box>

    <br />

    <Flex w="100%" gap={2}  >
      {/* Prima DescriptionCard */}
      <Box flex={1} marginLeft={"2%"} >
        <DescriptionCardWP
          title="Query Tool"
          description="The query tool allows all users, thanks to Drag and Drop technology, to be able to build sql queries simply by dragging the desired blocks."
          ImgUrl={query_tool}
          path = '/info'
        />
      </Box>

      {/* Seconda DescriptionCard */}
      <Box flex={1} marginRight={"2%"}  w="50%">
        <DescriptionCardWP
          title="Upload Dataset"
          description=""
          ImgUrl={uploadDataset}
          path = '/info'
        />
      </Box>
      
    </Flex>
    <Box bg="#003b47" color="white" p={10} borderRadius="lg" margin={"2%"}>
      {/* Titolo principale */}
      <Flex justify="space-between" mb={8}>
        <Box maxW="50%">
          <Text fontSize="sm" color="#b4dbdb" mb={2}>
          ACTIVITIES ON THE PLATFORM
          </Text>
          <Heading as="h2" fontSize="3xl" mb={4}>
          What AmeliaDP offers.
          </Heading>
          <Text fontSize="lg">
          Amelia DP offers a wide selection of tools to analyze and study data. It allows the publication and observation of various types of catalogs through dedicated spaces and provides the ability to ingest a wide range of data formats          </Text>
        </Box>
        {/* Pulsante "Vedi Tutti" */}
        <Button variant="outline" borderColor="#b4dbdb" color="#b4dbdb" borderRadius="full" _hover={{ bg: "#b4dbdb", color: "#003b47" }} onClick={goToAmeliaDP}>
          GO TO AMELIADP
        </Button>
      </Flex>

      {/* Griglia con le aree */}
      <Grid templateColumns="repeat(3, 1fr)" gap={6}>
        {/* Card Area 01 */}
        <GridItem bg="white" borderRadius="lg" p={6} color="#003b47" position="relative">
          <Heading as="h4" size="md" mb={4}>
            Tools
          </Heading>
          <Text fontWeight="bold" mb={2}>What can I use?</Text>
          <Text href="#" color="#00686b" mb={1} display="block">
             - Query Tool
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
             - Statistical Tool
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
             - Jupyter
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
             - Zeppelin
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
             - Superset
          </Text>
          {/* Icona freccia */}
         
        </GridItem>

        {/* Card Area 02 */}
        <GridItem bg="white" borderRadius="lg" p={6} color="#003b47" position="relative">
          <Heading as="h4" size="md" mb={4}>
            Catalog
          </Heading>
          <Text fontWeight="bold" mb={2}>What can I observe?</Text>
          <Text href="#" color="#00686b" mb={1} display="block">
            - Datasets
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
            - Staging Area
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
            - Results
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
            - Processing
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
            - Dashboards
          </Text>
          {/* Icona freccia */}
          
        </GridItem>

        {/* Card Area 03 */}
        <GridItem bg="white" borderRadius="lg" p={6} color="#003b47" position="relative">
          <Heading as="h4" size="md" mb={4}>
          Supported Data Formats
          </Heading>
          <Text fontWeight="bold" mb={2}>What can I upload?</Text>
          <Text href="#" color="#00686b" mb={1} display="block">
            - Shapefile
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
            - Csv
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
            - Json
          </Text>
          <Text href="#" color="#00686b" mb={1} display="block">
            - Excel
          </Text>
          {/* Icona freccia */}
          
        </GridItem>
      </Grid>
    </Box>
  </Box>
  

)





}   